import { useState, useEffect } from "react"
import { Locale } from "../../locales"

interface TBody {
  _uid: string
  body: {
    _uid: string
    value: string
  }[]
}

interface Table {
  thead: {
    _uid: string
    value: string
  }[]
  tbody: TBody[]
}

const useGoogleSheets = (locale: Locale) => {
  const [data, setData] = useState<Table>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>()

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Attempt to fetch data for the requested locale
        const response = await fetch(`/api/getComparisonTable?locale=${locale}`)
        if (response.ok) {
          const respData = (await response.json()) as Table
          setData(respData)
        } else {
          if (locale === "default")
            throw new Error(`Error fetching data, response code ${response.status}`)
          // Fallback to "default" if the requested locale's data is unavailable
          const fallbackResponse = await fetch(`/api/getComparisonTable?locale=default`)
          if (!fallbackResponse.ok)
            throw new Error(`Error fetching fallback data, response code ${fallbackResponse.status}`)
          const fallbackData = (await fallbackResponse.json()) as Table
          setData(fallbackData)
        }
      } catch (fetchError: unknown) {
        setError(fetchError)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [locale])

  return { data, error, loading }
}

export default useGoogleSheets
